import { render } from "./ClientConfiguracionCorreos.vue?vue&type=template&id=4d0e9dac&scoped=true"
import script from "./ClientConfiguracionCorreos.vue?vue&type=script&lang=js"
export * from "./ClientConfiguracionCorreos.vue?vue&type=script&lang=js"

import "./ClientConfiguracionCorreos.vue?vue&type=style&index=0&id=4d0e9dac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0e9dac"]])

export default __exports__